import { AxiosRead } from "@/repositories/clients/AxiosReadClient";

const resource = 'store/packages';

export default {
    /**
     *  get one custom package by id
     *  ------------------------
     *  Api address| /api/v1/site/store/package/custom/:id
     *  ------------------------
     *  Method| GET
     *  ------------------------
     *  @Description| get one custom package by id
     *  ------------------------
     *  @param id {String} required | package id
     *  @param queryParams {Object} none-required
     *   -----------------------
     *  @return  type {Promise}
     *  ------------------------
     **/
    getOneCustom(id,queryParams = null){
        return AxiosRead.get(`${resource}/custom/${id}`, {
            params: {
                ...queryParams
            }
        });
    },

    /**
     *  get one package by id
     *  ------------------------
     *  Api address| /api/v1/site/store/package/:id
     *  ------------------------
     *  Method| GET
     *  ------------------------
     *  @Description| get one package by id
     *  ------------------------
     *  @param id {String} required | package id
     *  @param queryParams {Object} none-required
     *   -----------------------
     *  @return  type {Promise}
     *  ------------------------
     **/
    getOne(id,queryParams = null){
        return AxiosRead.get(`${resource}/${id}`, {
            params: {
                ...queryParams
            }
        });
    },
}